module.exports = __webpack_public_path__ + "img/ImageQresult2.16d42f93.png";